import React from 'react';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { Stack, Typography } from '@mui/material';
import { TextField } from 'components/TextField/TextField';
import { SecureTextField } from 'components/SecureTextField/SecureTextField';
import PasswordChecklist from 'components/SignUpForm/Steps/AccountCredentialsStep/PasswordChecklist';
import { useAccountCredentialsStep } from './useAccountCredentialsStep';

export const AccountCredentialsStep = () => {
  const { inputController, passwordValidation } = useAccountCredentialsStep();
  const { translation } = useTranslationContext();

  return (
    <Stack className="account-credentials-step" justifyContent="flex-start">
      <Stack className="account-credentials-step__header" spacing={3}>
        <Typography className="header__title" variant="h5" color="primary">
          {translation('account_header')}
        </Typography>
        <Typography className="header__subtitle" variant="body1" color="grey.800">
          {translation('account_member_body')}
        </Typography>
      </Stack>
      <Stack className="acount-credentials-step__form" spacing={3} paddingTop={4}>
        <TextField
          id="signup_email-address-text-field"
          label={translation('email_address')}
          error={
            inputController.memberEmail.fieldState.isTouched &&
            !!inputController.memberEmail.fieldState.error
          }
          helperText={
            inputController.memberEmail.fieldState.isTouched
              ? inputController.memberEmail.fieldState.error?.message
              : undefined
          }
          autoComplete="email"
          {...inputController.memberEmail.field}
        />
        <TextField
          id="signup_confirmed-email-address-text-field"
          label={translation('confirm_email_address')}
          error={
            inputController.memberConfirmedEmail.fieldState.isTouched &&
            !!inputController.memberConfirmedEmail.fieldState.error
          }
          helperText={
            inputController.memberConfirmedEmail.fieldState.isTouched
              ? inputController.memberConfirmedEmail.fieldState.error?.message
              : undefined
          }
          autoComplete="email"
          {...inputController.memberConfirmedEmail.field}
        />
        <SecureTextField
          id="signup__password-text-field"
          label={translation('password')}
          error={
            inputController.password.fieldState.isTouched &&
            !!inputController.password.fieldState.error
          }
          helperText={
            inputController.password.fieldState.isTouched
              ? inputController.password.fieldState.error?.message
              : undefined
          }
          autoComplete="new-password"
          {...inputController.password.field}
        />
        <PasswordChecklist validationResults={passwordValidation.results} />
        <SecureTextField
          id="signup_confirmed-password-text-field"
          label={translation('confirm_password')}
          error={
            inputController.confirmedPassword.fieldState.isTouched &&
            !!inputController.confirmedPassword.fieldState.error
          }
          helperText={
            inputController.confirmedPassword.fieldState.isTouched
              ? inputController.confirmedPassword.fieldState.error?.message
              : undefined
          }
          autoComplete="new-password"
          {...inputController.confirmedPassword.field}
        />
      </Stack>
    </Stack>
  );
};
